<template>
    <div class="sino-wealth" >
        <!-- ============= 顶部菜单栏 ============= -->
        <el-header class="sw-header" style="padding: 0;">
          <sw-header></sw-header>
        </el-header>

        <!-- ============= 主页面 ============= -->
        <el-main class="sw-main">
          <router-view></router-view>
        </el-main>

        <!-- ============= 底部工具栏 ============= -->
        <el-footer class="sw-footer">
          <sw-footer></sw-footer>
        </el-footer>
    </div>
</template>



<script>
    import SwHeader from '@/components/header'
    import SwFooter from '@/components/footer'

    export default {
        name: "home",

        mounted: function () {
            
        },

        data() {
          return {
          }
        },
        methods: {
          judgeVersions(){
            // 判断是否是IE浏览器
            if (!!window.ActiveXObject || 'ActiveXObject' in window) {
              // 判断IE浏览器版本
              if (navigator.appName === 'Microsoft Internet Explorer' && parseInt(navigator.appVersion.split(';')[1].replace(/[ ]/g, '').replace('MSIE', '')) < 10) {
                document.write("<div style='position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 10000; width: 100%; height: 100%; padding-top: 200px;  background-color: #fff'><P  style='font-size: 50px; text-align: center'>请使用高版本IE10及以上浏览器或者其他主流浏览器！</P></div>")
              }
            }
          }
        },

        components: {
          SwHeader,
          SwFooter
        }
    }
</script>

<style>
     html,body {/*! autoprefixer: off */ margin: 0;padding-top: 0;min-height: 100%;height: 0; /*! autoprefixer: on */}
    .sw-header {/*! autoprefixer: off */  height: 107px !important;padding: 0; /*! autoprefixer: on */}
    .sw-main {/*! autoprefixer: off */ width: 100%;padding: 0;  /*! autoprefixer: on */}
    .el-main {/*! autoprefixer: off */ overflow: inherit;padding: 0 /*! autoprefixer: on */}
    .sw-footer { width: 100%;padding: 0 !important; }
</style>



// WEBPACK FOOTER //
// src/pages/home.vue